export default function () {
    return {
        campaigns: [],
    }
}